import { render, staticRenderFns } from "./BrigadeAutoAssign.vue?vue&type=template&id=39064006&"
import script from "./BrigadeAutoAssign.vue?vue&type=script&lang=js&"
export * from "./BrigadeAutoAssign.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeAutoAssign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCheckbox,QTabs,QTab,QBadge,QSeparator} from 'quasar'
component.options.components = Object.assign({QCheckbox,QTabs,QTab,QBadge,QSeparator}, component.options.components || {})
